import { render, staticRenderFns } from "./ChatDialog.vue?vue&type=template&id=5f75822a&scoped=true"
import script from "./ChatDialog.vue?vue&type=script&lang=js"
export * from "./ChatDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatDialog.vue?vue&type=style&index=0&id=5f75822a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f75822a",
  null
  
)

export default component.exports